import { toApiUrl } from '../../config/api';

export const HELP_CACHE_KEY = 'crickarena.help-center.catalog.v1';
export const RECENT_KEY = 'crickarena.help-center.recent.v1';

export const ESSENTIAL_OFFLINE_ARTICLES = [
  { id:'network-error',slug:'network-error',category:'technical-problems',question:'What should I do after a network error?',answer:'Keep the operation safe, restore connectivity, reload canonical state, and never repeat a scoring, Sold, or Start action blindly.',keywords:['network','offline','retry'],relatedFaqIds:['blank-screen'],relatedModules:['Technical Problems'],popular:true },
  { id:'start-match-fails',slug:'start-match-fails',category:'troubleshooting',question:'Why will Start Match not proceed?',answer:'Complete every reported requirement, save configuration, then reload it. Date, time, teams, squads, officials, format, and toss may be required.',keywords:['start','match','date','time'],relatedFaqIds:['match-date-time'],relatedModules:['Matches'],popular:true },
  { id:'go-live',slug:'go-live',category:'streaming',question:'How do I start a mobile stream?',answer:'Open Streaming Control, confirm preflight, and tap Go Live. Publisher startup happens first; Live Ready appears only after required health signals pass.',keywords:['stream','publisher','live'],relatedFaqIds:['live-ready','permissions'],relatedModules:['Streaming'],popular:true },
  { id:'contact-support',slug:'contact-support',category:'general',question:'How do I contact support?',answer:'Email hello@crickarena.com with time, platform, version, role, safe identifiers, steps, and the error. Never send passwords, tokens, stream keys, or credentials.',keywords:['help','email','support'],relatedFaqIds:['report-problem'],relatedModules:['General'],popular:true },
];

export const searchArticles = (articles, query, category = '') => {
  const terms = String(query || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
  return articles.filter((article) => {
    if (category && article.category !== category) return false;
    if (!terms.length) return true;
    const text = [article.question, article.answer, ...(article.keywords || []), ...(article.relatedModules || [])].join(' ').toLowerCase();
    return terms.every((term) => text.includes(term));
  });
};

export const fetchHelpCatalog = async () => {
  try {
    const response = await fetch(toApiUrl('/api/help-center'));
    if (!response.ok) throw new Error(`Help Center request failed (${response.status})`);
    const catalog = await response.json();
    window.localStorage.setItem(HELP_CACHE_KEY, JSON.stringify(catalog));
    return { ...catalog, offline: false };
  } catch (error) {
    const cached = window.localStorage.getItem(HELP_CACHE_KEY);
    if (cached) return { ...JSON.parse(cached), offline: true };
    return { version:'1.0.0',categories:[{id:'technical-problems',name:'Technical Problems'},{id:'troubleshooting',name:'Troubleshooting'},{id:'streaming',name:'Streaming'},{id:'general',name:'General'}],articles:ESSENTIAL_OFFLINE_ARTICLES,offline:true };
  }
};

export const rememberArticle = (slug) => {
  const current = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
  window.localStorage.setItem(RECENT_KEY, JSON.stringify([slug, ...current.filter((item) => item !== slug)].slice(0, 6)));
};
